import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'payment_methods',
            name: 'paymentMethod',
            class: 'Modules\\Ecommerce\\Entities\\PaymentMethod'
        }
    }
}